<template>
  <li class="list_once">
    <p class="p">如何创建文件发起审批</p>
    <p class="text">1.在首页中点击“企业控制台”进入企业管理界面；</p>
    <img class="img" src="/images/home/sign_img10.png" alt="">
    <p class="text">2.点击“成员合同审批”，进入文件发起时审批页面，点击新增审批；</p>
    <img class="img" src="/images/home/sign_img11.png" alt="">
    <p class="text">3.根据页面展示，填写对应内容或选择对应选项，点击确定即可创建成功。（若使用范围未选择，则全体企业成员在合同发起时均可选择使用此流程）</p>
    <img class="img" src="/images/home/sign_img12.png" alt="">
  </li>
</template>
<script>
  export default {
    data () {
      // 这里存放数据
      return {}
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {},
  }
</script>
<style lang='less' scoped>
  // @import url(); 引入公共css类
  .list_once {
    font-size: 14px;
    padding: 10px;
    .p {
      font-size: 16px;
      font-weight: bold;
    }
    .text {
      margin: 10px 0;
    }
    .img {
      max-width: 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// pages/dingtalkUse/helpCenterCom/4_apprFile.vue